module.exports = __webpack_public_path__ + "img/logo-CH.e712fc64.svg";